// extracted by mini-css-extract-plugin
export default {"wrapper":"targetFiltering_wrapper__SKIbO","targetWrapper":"targetFiltering_targetWrapper__V9zO3","subTitle":"targetFiltering_subTitle__aV-fO"};